import type {EnabledFeaturesMap} from '../api/enabled-features/contracts'
import {getEnabledFeatures} from '../helpers/feature-flags'

// eslint-disable-next-line @eslint-react/hooks-extra/no-unnecessary-use-prefix
export const useEnabledFeatures = (): EnabledFeaturesMap => {
  return getEnabledFeatures()
}
